











import Vue from 'vue';

import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import FilterSection from '@/components/filter/FilterSection.vue';
import { FilterOption } from '@/models';
import MultipleSelectMixin from '@/mixins/MultipleSelectMixin.vue';
import MultipleSelect from '../shared/MultipleSelect.vue';

@Component({
  mixins: [MultipleSelectMixin],
  components: {
    FilterSection,
    MultipleSelect,
  },
})
export default class HistoricOutcomeFilter extends Vue {
  @Getter('historicListOutcomeOptions', { namespace: 'schemes' })
  private options!: FilterOption[];

  @Getter('selectedHistoricListOutcomeOptions', { namespace: 'schemes' })
  private selected!: string[];

  public title = 'Outcome';

  public toggleCheckbox(options) {
    this.$emit('on-histories-outcome-change', options);
  }
}
